import React, { useState, useEffect, useRef, memo } from "react";
import { useMutation, useQuery } from "@apollo/client";
import {
  REQUEST_RESET,
  RESET_PASSWORD,
  SEND_EMAIL_MUTATION,
  UPDATE_TOKEN,
  updateProfile,
} from "../../graphql/mutations";
import jwtDecode from "jwt-decode";
import {
  Box,
  Card,
  CardContent,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Snackbar,
  Alert,
  Tab,
  CircularProgress,
  Grid,
  Tabs,
  Typography,
  Link,
  useMediaQuery,
} from "@mui/material";
import { Launch, OpenInNew } from "@mui/icons-material";
import moment from "moment-timezone";
import { Timezones_List, getTimezoneInfo } from "../../util/timezones";
import HourFormat from "../../util/hourFormat";
import { format, isSameDay, isSameHour, isSameMinute, parse } from "date-fns";
import { DateTime } from "luxon";
import { GET_SUBSCRIPTIONS } from "../../graphql/querys";
import Error from "../Error";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ display: value === index ? "block" : "none" }} // Add this line
    >
      <Box sx={{ p: 3 }}>
        <Typography>{children}</Typography>
      </Box>
    </div>
  );
};

const UserPage = (props) => {
  const isXsScreen = useMediaQuery("(max-width:800px)");
  let now = new Date();
  const token =
    localStorage.getItem("token") &&
    localStorage.getItem("token") !== "undefined"
      ? localStorage.getItem("token")
      : null;
  var decodedToken = token && token !== "undefined" ? jwtDecode(token) : null;
  const [updateToken] = useMutation(UPDATE_TOKEN);
  const [update] = useMutation(updateProfile);
  const [userDetails, setUserDetails] = useState(props.data);
  const [username, setUsername] = useState(userDetails.username);
  const [email, setEmail] = useState(userDetails.email);
  const [link, setLink] = useState(userDetails.url);
  const [desc, setDesc] = useState(userDetails.desc);
  const [select, setSelect] = useState(
    decodedToken.hours24 ? "24hrs" : "12hrs"
  );
  const [timezone, setTimezone] = useState(userDetails.timezone);
  const [calendar, setCalendar] = useState(userDetails.calendar);
  const [updated, setUpdated] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(false);
  const timerRef = useRef(null);
  const timerRef2 = useRef(null);
  const notificationRef = useRef(null);
  const notificationRef2 = useRef(null);
  const formRef = useRef(null);
  const [errors, setErrors] = useState("");
  const [sendEmail] = useMutation(SEND_EMAIL_MUTATION);
  const {
    loading,
    error: testError,
    data: getSubscriptions,
    refetch,
  } = useQuery(GET_SUBSCRIPTIONS, {
    variables: { userId: props.data.userId },
  });
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (updated) {
        // Prompt the user to confirm leaving the page
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [updated]);
  const handleSubmit = (event) => {
    event.preventDefault();
    if (username.length > 20) {
      setErrors("username");
      return;
    }
    if (desc.length > 250 || !desc) {
      setErrors("desc");
      return;
    }
    setUpdated(false);

    if (token) {
      const token = localStorage.getItem("token");
      // Send the token to the backend to update it
      updateToken({
        variables: {
          token,
          username,
          hours24: select == "12hrs" ? false : true,
          url: link,
          timezone,
          desc,
          calendar,
        },
      })
        .then((newToken) => {
          update({
            variables: {
              userId: userDetails.userId,
              email,
              username,
              url: link,
              hours24: select == "24hrs",
              timezone,
              desc,
              calendar,
            },
          })
            .then(() => {
              setErrors("");
              // Log the returned new token
              console.log("New token:", newToken);
              // Set the new token in localStorage
              localStorage.setItem("token", newToken.data.updateToken);
              setUpdating(true);
            })
            .catch((err) => {
              console.log(err.message);
              if (err.message == "Url exists") {
                setErrors("link");
              }
            });
        })
        .catch((error) => {
          if (JSON.stringify(error).includes("jwt")) {
            setError(true);
          }
        });
    }
  };
  useEffect(() => {
    if (notificationRef.current) {
      notificationRef.current.style.height = "0px";

      if (updating) {
        notificationRef.current.style.transition = "height 0.3s ease";
        notificationRef.current.style.height = "50px";
      } else {
        notificationRef.current.style.height = "0px";
      }
    }
  }, [updating]);
  useEffect(() => {
    if (notificationRef2.current) {
      notificationRef2.current.style.height = "0px";

      if (updating) {
        notificationRef2.current.style.transition = "height 0.3s ease";
        notificationRef2.current.style.height = "50px";
      } else {
        notificationRef2.current.style.height = "0px";
      }
    }
  }, [updating]);
  useEffect(() => {
    if (updating) {
      // Show notification for 2 seconds
      timerRef.current = setTimeout(() => {
        setUpdating(false);
      }, 3000);
    } else {
      // Cancel any pending timers
      clearTimeout(timerRef.current);
    }
  }, [updating]);
  useEffect(() => {
    if (error) {
      // Show notification for 2 seconds
      timerRef2.current = setTimeout(() => {
        setError(false);
      }, 3000);
    } else {
      // Cancel any pending timers
      clearTimeout(timerRef2.current);
    }
  }, [error]);
  const handleSelectChange = (e) => {
    setUpdated(true);
    const newSelectValue = e.target.value;
    setSelect(newSelectValue);

    // Get the existing token from localStorage
  };
  const change = (e, set) => {
    set(e.target.value);
    setUpdated(true);
  };
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  // Mutation hooks
  const [requestReset, { data: requestResetData }] = useMutation(REQUEST_RESET);
  const [resetPassword, { data: resetPasswordData }] =
    useMutation(RESET_PASSWORD);
  const [resetToken, setResetToken] = useState("");
  const [requested, setRequested] = useState(false);
  const handleRequestResetToken = async (e) => {
    e.preventDefault();
    setRequested(true);
    try {
      const response = await requestReset({
        variables: {
          email: userDetails.email,
        },
      });
      sendEmail({
        variables: {
          to: userDetails.email,
          subject: "Reset Token",
          text: "Your reset token is: " + response.data.requestReset.resetToken,
        },
      });
      alert("Reset token has been sent to your email");
    } catch (err) {
      console.error(err);
      alert("An error occurred while requesting the reset token");
    }
  };
  const handleResetPassword = async (e) => {
    e.preventDefault();

    // Validating the new password and confirmation password match
    if (newPassword !== confirmNewPassword) {
      alert("Password and confirmation do not match");
      return;
    }

    try {
      await resetPassword({
        variables: {
          email: userDetails.email,
          password: newPassword,
          resetToken: resetToken,
        },
      });
      alert("Your password has been reset");
    } catch (err) {
      console.error(err);
      alert("An error occurred while resetting the password");
    }
  };
  console.log(Timezones_List);
  const timezones = Timezones_List;
  const sortedTimezones = timezones.sort((a, b) => {
    const timeA = moment().tz(a.timezone).format("HH:mm");
    const timeB = moment().tz(b.timezone).format("HH:mm");
    return timeA.localeCompare(timeB);
  });
  const [plan, setPlan] = useState(props?.data?.role);
  if (loading) {
    return <CircularProgress />;
  } else if (testError) {
    return <Error />;
  }
  const handlePlanChange = (event) => {
    setPlan(event.target.value);
  };

  const handleSubscriptionUpdate = () => {
    // updateSubscription({
    //   variables: { userId: props.data.userId, newRole: plan },
    // });
  };
  return (
    <Grid
      container
      justifyContent="center"
      style={{ marginTop: "40px", paddingBottom: "40px" }}
    >
      <Grid
        item
        xs={12}
        sm={8}
        lg={8}
        className="flex align column"
        style={{ flexDirection: "column" }}
      >
        <Card raised style={{ width: "100%", maxWidth: "1000px" }}>
          <CardContent>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="General" />
              <Tab label="Account" />
              <Tab label="Change Password" />
              <Tab label="Subscription & Billing" />
            </Tabs>
            <TabPanel value={tabValue} index={0}>
              <div className="flex column">
                <Typography variant="h5">General</Typography>
                <FormControl margin="normal">
                  <TextField
                    label="Username"
                    variant="outlined"
                    value={username}
                    onChange={(e) => change(e, setUsername)}
                    error={errors === "username"}
                    helperText={
                      errors === "username" && "Enter a shorter username"
                    }
                  />
                </FormControl>
                <FormControl margin="normal">
                  <TextField
                    label="Email"
                    variant="outlined"
                    value={email}
                    disabled
                    onChange={(e) => change(e, setEmail)}
                  />
                </FormControl>
                <FormControl margin="normal">
                  <InputLabel id="time-format-label">Time Format</InputLabel>
                  <Select
                    label="Time Format"
                    labelId="time-format-label"
                    id="time-format-select"
                    value={select}
                    onChange={handleSelectChange}
                  >
                    <MenuItem value="12hrs">12hrs</MenuItem>
                    <MenuItem value="24hrs">24hrs</MenuItem>
                  </Select>
                </FormControl>{" "}
                <FormControl margin="normal">
                  <InputLabel id="timezone-label">Timezone</InputLabel>
                  <Select
                    label="Timezone"
                    labelId="timezone-label"
                    id="timezone-select"
                    value={timezone}
                    onChange={(e) => {
                      setTimezone(e.target.value);
                      setUpdated(true);
                    }}
                  >
                    {sortedTimezones.map((tz) => {
                      const formattedTimezone = moment()
                        .tz(tz.timezone)
                        .format(HourFormat() === "h:mmaa" ? "h:mma" : "HH:mm");
                      const isCurrentTimezone =
                        isSameHour(
                          parse(formattedTimezone, HourFormat(), new Date()),
                          new Date()
                        ) &&
                        isSameMinute(
                          parse(formattedTimezone, HourFormat(), new Date()),
                          new Date()
                        );
                      return (
                        <MenuItem key={tz.timezone} value={tz.id}>
                          {formattedTimezone} - {tz.name}
                          <b
                            style={{
                              display: isCurrentTimezone ? "block" : "none",
                            }}
                          >
                            Your Time
                          </b>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormControl margin="normal">
                  <InputLabel id="calendar-label">
                    Calendar Type {"(Beta)"}
                  </InputLabel>
                  <Select
                    label="Calendar Type (Beta)"
                    labelId="calendar-label"
                    id="calendar-select"
                    value={calendar}
                    onChange={(e) => {
                      setCalendar(e.target.value);
                      setUpdated(true);
                    }}
                  >
                    <MenuItem value="Gregorian">
                      Gregorian Calendar(default)
                    </MenuItem>
                    <MenuItem value="Ethiopian">Ethiopian Calendar</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={!updated}
                  sx={{ mt: 2 }}
                >
                  Save
                </Button>
              </div>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <Typography variant="h5" gutterBottom>
                Account
              </Typography>
              <FormControl margin="normal" fullWidth>
                <TextField
                  label="Company Page"
                  variant="outlined"
                  value={link}
                  onChange={(e) => {
                    setErrors("");
                    setUpdated(true);
                    setLink(e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <Link href={`/${link}`}>
                        <OpenInNew style={{ cursor: "pointer" }} />
                      </Link>
                    ),
                  }}
                  error={errors === "link"}
                  helperText={
                    errors === "link" && "Please use a different link"
                  }
                />
              </FormControl>
              <FormControl margin="normal" fullWidth>
                <TextField
                  label="Description"
                  variant="outlined"
                  rows={3}
                  multiline
                  value={desc}
                  onChange={(e) => {
                    setErrors("");
                    setUpdated(true);
                    setDesc(e.target.value);
                  }}
                  error={errors === "desc"}
                  helperText={
                    errors === "desc" && "Please provide a proper description"
                  }
                />
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={!updated}
              >
                Save
              </Button>
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <Typography variant="h5" gutterBottom>
                Change Password
              </Typography>
              <Button
                variant="contained"
                disabled={requested}
                color="primary"
                onClick={handleRequestResetToken}
                sx={{ mt: 2 }}
              >
                Request Password Reset Token
              </Button>
              <FormControl margin="normal" fullWidth>
                <TextField
                  label="Reset Token"
                  variant="outlined"
                  value={resetToken}
                  onChange={(e) => setResetToken(e.target.value)}
                />
              </FormControl>
              <FormControl margin="normal" fullWidth>
                <TextField
                  label="New Password"
                  variant="outlined"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </FormControl>
              <FormControl margin="normal" fullWidth>
                <TextField
                  label="Confirm New Password"
                  variant="outlined"
                  type="password"
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                onClick={handleResetPassword}
                sx={{ mt: 2 }}
              >
                Reset Password
              </Button>
            </TabPanel>
            <TabPanel value={tabValue} index={3}>
              <div
                className={"flex" + (isXsScreen ? " column" : "")}
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  <Typography variant="h5" gutterBottom>
                    Subscription & Billing
                  </Typography>

                  <Typography variant="subtitle1" gutterBottom>
                    Current Plan: {plan}
                  </Typography>
                  <Button
                    variant="contained"
                    href="/pricing"
                    startIcon={<Launch />}
                  >
                    Change Plan
                  </Button>
                </div>
                <Card style={{ padding: "25px" }}>
                  <Typography variant="h5" gutterBottom>
                    Past Plans
                  </Typography>
                  <div
                    className="flex column"
                    style={{
                      gap: "20px",
                      margin: "20px 0",
                      padding: "10px 20px 10px 10px",
                      overflow: "auto",
                      maxHeight: "350px",
                    }}
                  >
                    {getSubscriptions.getSubscriptions.length == 0 ? (
                      <Typography className="font2" variant="h4">
                        No Past Plans
                      </Typography>
                    ) : (
                      getSubscriptions.getSubscriptions
                        .map((val) => {
                          return {
                            ...val,
                            subscribedOnDate: parseInt(val.subscribedOnDate),
                            unsubscribedOnDate: val.unsubscribedOnDate
                              ? parseInt(val.unsubscribedOnDate)
                              : null,
                          };
                        })
                        .map((sub) => (
                          <div
                            key={sub.id}
                            style={{
                              boxShadow:
                                "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                              padding: "20px",
                            }}
                          >
                            <div
                              className="flex align"
                              style={{ justifyContent: "space-between" }}
                            >
                              <Typography className="font" variant="h5">
                                {sub?.role[0].toUpperCase() +
                                  sub?.role?.slice(1)}
                              </Typography>
                              <Typography className="font2">
                                {sub?.type[0].toUpperCase() +
                                  sub?.type?.slice(1)}
                              </Typography>
                            </div>
                            <p>
                              Start Date:{" "}
                              {format(
                                new Date(sub.subscribedOnDate),
                                "EEEE, MMMM dd yyyy"
                              )}
                            </p>
                            <p>
                              End Date:{" "}
                              {sub.unsubscribedOnDate
                                ? format(
                                    new Date(sub.unsubscribedOnDate),
                                    "EEEE, MMMM dd yyyy"
                                  )
                                : "Ongoing"}
                            </p>
                            <p>
                              Status:{" "}
                              {sub.unsubscribedOnDate ? "Inactive" : "Active"}
                            </p>
                          </div>
                        ))
                    )}
                  </div>
                </Card>
              </div>
            </TabPanel>
          </CardContent>
        </Card>
        <Snackbar open={updating} autoHideDuration={3000}>
          <Alert severity="success">Changes Saved!</Alert>
        </Snackbar>
        <Snackbar open={error} autoHideDuration={3000}>
          <Alert severity="error">Token Expired!(Login Again)</Alert>
        </Snackbar>
        <Button
          variant="contained"
          color="secondary"
          onClick={props.logout}
          sx={{ mt: 2 }}
        >
          Logout
        </Button>
      </Grid>
    </Grid>
  );
};

export default UserPage;
